
import { useEffect } from 'react';
import {  useAction } from '../hooks';

const useRequestSettings = () => {

  const transaction = useAction('transaction.getList');
  const ownershipType = useAction('ownershipType.getList');
  const serviceType = useAction('serviceType.getList');

  useEffect(() => {
    transaction();
    ownershipType()
    serviceType()
  // eslint-disable-next-line
  }, [])
}

export default useRequestSettings